export default function(api: GlobalFetch) {
  return async function(email: string, password: string): Promise<boolean> {
    const requestBody = { email, password }
    const response = await api.fetch(`/api/v2/user/index`, {
      body: JSON.stringify(requestBody),
      method: 'PUT',
    })

    if (response.status !== 200) {
      throw new Error('Updating user rejected')
    }

    return response.status === 200
  }
}
